<carta-map class="map" [center]="[8.226667, 46.801111]" [initZoom]="8" [interactions]="{mouseWheelZoom: false}">
    <carta-xyz-layer
            url="https://api.mapbox.com/styles/v1/sebubu/cjix2wzyu0y2a2rmwfctb5676/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2VidWJ1IiwiYSI6ImNqbjRrNXI3bDBxdTQzcXJ1N3lpcHdnbWgifQ.X2IUFyplxjbkel5UqU4lCA"
            retinaUrl="https://api.mapbox.com/styles/v1/sebubu/cjix2wzyu0y2a2rmwfctb5676/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic2VidWJ1IiwiYSI6ImNqZGxsdm85czA1N2Uyd3BjOWdsOGFnc3IifQ.2oxeuQlVi1zVoY_39M8GJA"
    ></carta-xyz-layer>
    <carta-drawing-layer [removeAllAreasOption]="true" [ngModel]="areas" [style]="style"></carta-drawing-layer>
    <carta-search-layer></carta-search-layer>
    <carta-geojson-layer *ngIf="enableGeojson" [areas]="areas" [filename]="'aymo-map'">
    </carta-geojson-layer>
</carta-map>

